"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  LayoutContext: true,
  Root: true,
  Header: true,
  Nav: true,
  Content: true,
  Footer: true,
  presets: true,
  useConfig: true,
  useWidth: true,
  useHeightAdjustment: true,
  useAutoCollapse: true
};
Object.defineProperty(exports, "LayoutContext", {
  enumerable: true,
  get: function get() {
    return _context["default"];
  }
});
Object.defineProperty(exports, "Root", {
  enumerable: true,
  get: function get() {
    return _Root["default"];
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _Header["default"];
  }
});
Object.defineProperty(exports, "Nav", {
  enumerable: true,
  get: function get() {
    return _Nav["default"];
  }
});
Object.defineProperty(exports, "Content", {
  enumerable: true,
  get: function get() {
    return _Content["default"];
  }
});
Object.defineProperty(exports, "Footer", {
  enumerable: true,
  get: function get() {
    return _Footer["default"];
  }
});
Object.defineProperty(exports, "presets", {
  enumerable: true,
  get: function get() {
    return _presets["default"];
  }
});
Object.defineProperty(exports, "useConfig", {
  enumerable: true,
  get: function get() {
    return _useConfig["default"];
  }
});
Object.defineProperty(exports, "useWidth", {
  enumerable: true,
  get: function get() {
    return _useWidth["default"];
  }
});
Object.defineProperty(exports, "useHeightAdjustment", {
  enumerable: true,
  get: function get() {
    return _useHeightAdjustment["default"];
  }
});
Object.defineProperty(exports, "useAutoCollapse", {
  enumerable: true,
  get: function get() {
    return _useAutoCollapse["default"];
  }
});

var _context = _interopRequireDefault(require("./context"));

var _Root = _interopRequireDefault(require("./components/Root"));

var _Header = _interopRequireDefault(require("./components/Header"));

var _Nav = _interopRequireDefault(require("./components/Nav"));

var _Content = _interopRequireDefault(require("./components/Content"));

var _Footer = _interopRequireDefault(require("./components/Footer"));

var _presets = _interopRequireWildcard(require("./utils/presets"));

Object.keys(_presets).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _presets[key];
    }
  });
});

var _useConfig = _interopRequireDefault(require("./hooks/useConfig"));

var _useWidth = _interopRequireDefault(require("./hooks/useWidth"));

var _useHeightAdjustment = _interopRequireDefault(require("./hooks/useHeightAdjustment"));

var _useAutoCollapse = _interopRequireDefault(require("./hooks/useAutoCollapse"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }